export default function initialString(name: string) {
  const words = name.split(' ');
  return words
    .filter((word) => /^[A-Za-z]/.test(word)) // Filter out words that do not start with an alphabetic character
    .map((word) => word[0]?.toUpperCase()) // Map the remaining words to their first letter
    .join(''); // Join the letters to form the final string
}
